export class Tempdata {
  idModel : String;
id : String;
objectemp : Object;
user  : String;
dateCreated: String;
userLastUpdate : String;
dateUpdated: Date;
}
